import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {map, tap, switchMap} from 'rxjs/operators';
import {ProfileService} from './profile.service';
import {ToastrService} from 'ngx-toastr';

@Injectable()
export class PostLimitGuard implements CanActivate {

  constructor(
    private router: Router,
    private profileService: ProfileService,
    private notifierService: ToastrService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.profileService.hasActivePostLimit().pipe(
      map(
        (condition: boolean) => {
          if (!condition) {
            this.notifierService.warning('The credit limit has been exhausted');
            this.router.navigate(['/payment/add']);
          }
          return condition;
        }
      )
    );
  }

}
